import { ScreenSizes } from 'src/styles'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: var(--gray-200);
  border-radius: var(--border-radius);
  overflow: hidden;
  position: relative;
  aspect-ratio: 16/9;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;

    @media (min-width: ${ScreenSizes.sm}) {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
`

Wrapper.displayName = 'Wrapper'
